export default {
	"当前存在正在编辑的题目无法创建新题目": '当前存在正在编辑的题目，无法创建新题目',
	"请添加页后再添加题目": '请添加页后再添加题目',
	"此链接可分享到外部进行测试项目结束后链接自动失效": '此链接可分享到外部进行测试，项目结束后链接自动失效',
	"此测试仅针对系统内登录后测试分享如无系统账号无法打开慎用": '此测试仅针对系统内登录后测试，分享如无系统账号无法打开，慎用',
	"确定提交": '确定提交',
	"删除成功": '删除成功',
	"确定要删除文件": '确定要删除文件',
	"答案必须为数字": '答案必须为数字',
	"答案不在范围内": '答案不在范围内',
	"最多上传": '最多上传',
	"个附件": '个附件',
	"最少上传": '最少上传',
	"存在未参与排序的选项": '存在未参与排序的选项',
	"最少排": '最少排',
	"最多只能排": '最多只能排',
	"项": '项',
	"问题半开放未填": '问题半开放未填',
	"矩阵半开放未填": '矩阵半开放未填',
	"选项半开放未填": '选项半开放未填',
	"成功": '成功',
	"清除成功": '清除成功',
	"上传成功": '上传成功',
	"提交成功": '提交成功',
	"您有题目未作答请作答后提交": '您有题目未作答,请作答后提交',
	"该题已作答": '该题已作答',
	"最多选择": '最多选择',
	"只能上传图片": '只能上传图片',
	"只能上传视频": '只能上传视频',
	"只能上传图片或视频": '只能上传图片或视频',
	"上传失败": '上传失败',
	"请输入": '请输入',
	"请输入手机号": '请输入手机号',
	"手机号有误": '手机号有误',
	"手机号不能为空": '手机号不能为空',
	"同一个设备只能填一次": '同一个设备只能填一次',
	"请设置题号": '请设置题号',
	"请选择题型": '请选择题型',
	"选择题型": '选择题型',
	"必填": '必填',
	"配额题": '配额题',
	"题目": '题目',
	"问题描述": '问题描述',
	"请在这里输入": '请在这里输入',
	"请填写题号": '请填写题号',
	"题号": '题号',
	"请填写题目": '请填写题目',
	"必填项未填": '必填项未填',
	"超出上传文件限制的个数": '超出上传文件限制的个数',
	"上传图片只能是jpg或者png格式": '上传图片只能是jpg或者png格式',
	"确定移除": '确定移除',
	"存在重复的值请修改后提交": '存在重复的值，请修改后提交',
	"请选择": '请选择',
	"不能为空": '不能为空',
	"请输入随机的选项若勾选全部随机则不需要填写": '请输入随机的选项，若勾选全部随机则不需要填写',
	"请输入不随机的选项": '请输入不随机的选项',
	"请输入行问题的选项若勾选全部随机则不需要填写": '请输入行问题的选项，若勾选全部随机则不需要填写',
	"请输入随机的问题若勾选全部随机则不需要填写": '请输入随机的问题，若勾选全部随机则不需要填写',
	"表示问题随机": '表示值为1,2,3的问题随机，用英文逗号隔开',
	"请输入列随机": '请输入列随机的问题，若勾选全部随机则不需要填写',
	"答题时限有误": '答题时限有误',
	"请选择量表类型": '请选择量表类型',
	"请输入类型名称": '请输入类型名称',
	"请输入选项数量": '请输入选项数量',
	"选项数量必须是数字": '选项数量必须是数字',
	"默认样式最大数量": '默认样式最大数量为10',
	"最大上传数不能小于最小上传数":'最大上传数不能小于最小上传数',
	"值不能为空":'值不能为空',
	"值必须为数字":'值必须为数字',
	"选项不能为空":'选项不能为空',
	"问题不能为空":'问题不能为空',
	"问卷已发布修改可能造成问卷出错请谨慎操作":'问卷已发布，修改可能造成问卷出错请谨慎操作。若确需修改，修改后勿忘点击保存按钮',
	"复制题目错误请重新复制":'复制题目错误，请重新复制',
	"复制成功":'复制成功，可在新建一题处粘贴',
	"确认要删除此题":'确认要删除此题？',
	"分类名称不能为空":'分类名称不能为空',
	"添加成功":'添加成功',
	"请填写划线内容":'请填写划线内容',
	"划线内容未填":'划线内容未填',
	"请选择量表类型":'请选择量表类型',
	"确定删除此页":'确定删除此页？',
	"这是最后一页了":'这是最后一页了',
	"该项目已发布如再使用导入可能产生无法挽回的后果":'该项目已发布，如再使用导入可能产生无法挽回的后果，请谨慎使用！确实要导入请点击‘是’，取消请点‘否’。',
	"是否复制分享链接":'是否复制分享链接',
	"超出文件上传数量":'超出文件上传数量',
	"产品至少有一页数据":'产品至少有一页数据',
  "请签名后保存":'请签名后保存',
  "联动选项":'联动选项',
  "请上传csv格式文件":'请上传csv格式文件',
  "联动选项未填":'联动选项未填',
  "请勾选":'请勾选',
  "标注图片未传":'标注图片未传',
  "示例":'示例'
	
}